import Helpers from "@/util/Helpers";

export default ({ instance, baseURL, headers }) => {
    const apiCalls = {
        login(user) {                            
            return instance({
                method: 'post',
                baseURL,
                url: 'Autenticacao/Autenticar',
                responseType: 'json',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSS-Protection': '1; mode=block',
                    'X-Content-Type-Options': 'nosniff',
                    'Content-Security-Policy': "script-src 'self' scripts.intimacao.kurierservicos.com.br; media-src 'self'; img src *; default-src 'self' https://*.intimacao.kurierservicos.com.br"
                  },
                data: Helpers.aplicarValidacoes(user),                
            });
        },
        inserirUsuario(user) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Usuario/InserirUsuario',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(user),
            });
        },
        getUsersExibicao(filters) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Usuario/RecuperarUsuariosExibicao',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(filters),
            });
        },
        buscarUsuarioId(id) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Usuario/BuscarUsuarioId',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({ 'idUsuario': id }),
            });
        },
        atualizarUsuario(usuario, idUserAlteracao) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Usuario/EditarUsuario',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({ 'usuario': usuario, 'idUserAlteracao': idUserAlteracao }),
            })
        },
        atualizarSituacao(idUsuario, situacao, idUsuarioAlteracao) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Usuario/AtualizarSituacao',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({ 'idUsuario':idUsuario, 'situacao':situacao, 'idUsuarioAlteracao':idUsuarioAlteracao })
            });
        },
        atualizarSenha(idUsuario, novaSenha){            
            return instance({
                method: 'post',
                baseURL,
                url: 'Usuario/AtualizarSenha',
                responseType: 'json',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSS-Protection': '1; mode=block',
                    'X-Content-Type-Options': 'nosniff',
                    'Content-Security-Policy': "script-src 'self' scripts.intimacao.kurierservicos.com.br; media-src 'self'; img src *; default-src 'self' https://*.intimacao.kurierservicos.com.br"
                  },
                data: Helpers.aplicarValidacoes({"IdUsuario":idUsuario,"NovaSenha":novaSenha}),
            });
        },
        getUsuarioCliente(idCliente) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Usuario/RecuperarUsuarioCliente',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({"idCliente":idCliente }),
            });
        },
        esqueciMinhaSenha(login){
            return instance({
                method: 'post',
                baseURL,
                url: 'Usuario/EsqueciMinhaSenha',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({"login":login}),
            });
        },
        verificarSenhaAtual(idUsuario, senhaAtual){            
            return instance({
                method: 'post',
                baseURL,
                url: 'Usuario/VerificarSenhaAtual',
                responseType: 'json',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSS-Protection': '1; mode=block',
                    'X-Content-Type-Options': 'nosniff',
                    'Content-Security-Policy': "script-src 'self' scripts.intimacao.kurierservicos.com.br; media-src 'self'; img src *; default-src 'self' https://*.intimacao.kurierservicos.com.br"
                  },
                data: Helpers.aplicarValidacoes({"IdUsuario":idUsuario,"SenhaAtual":senhaAtual}),
            });
        },
        atualizarStatusTermoUso(idUsuario, statusTermoUso) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Usuario/AtualizarStatusTermoUso',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({ 'idUsuario': idUsuario, 'statusTermoUso': statusTermoUso })
            });
        },
    }
    return apiCalls;
};